import React from 'react';
import { Tooltip } from 'react-tooltip';
import { MapPinIcon, PhoneIcon } from '@heroicons/react/20/solid';
import {
  EnvelopeIcon,
  ChatBubbleBottomCenterTextIcon,
  LinkIcon,
} from '@heroicons/react/24/outline';
import NoStoreLogo from '../../../../assets/no-store-logo.svg';

const StoreHeader = ({
  store,
  onClickEmail,
  onClickSms,
  onClickReceipt,
  showActions = true,
}) => {
  const addressParts = [
    store?.address,
    store?.apartment && store.apartment !== 'null' ? store.apartment : null,
    store?.city,
    store?.state,
    store?.postalcode,
  ].filter(Boolean);
  const addressLine = addressParts.join(' ');

  const shareBtn =
    'group inline-flex h-9 w-9 items-center justify-center rounded-full text-slate-500 transition hover:bg-blue-500/10 hover:text-blue-600 active:scale-95 dark:text-slate-400 dark:hover:bg-sky-400/10 dark:hover:text-sky-400';

  return (
    <section
      className="reveal flex flex-col gap-4 rounded-md border border-slate-200 bg-white p-5 shadow-sm dark:border-slate-700 dark:bg-slate-800 sm:flex-row sm:items-center sm:justify-between"
      aria-label="Store information"
    >
      <div className="flex items-center gap-4">
        <div className="relative">
          <img
            className="h-16 w-16 rounded-md object-cover ring-2 ring-white shadow-sm dark:ring-slate-700"
            src={store?.storelogo || NoStoreLogo}
            alt={store?.name || 'Store'}
          />
        </div>
        <div className="min-w-0">
          <h1 className="truncate text-xl font-bold tracking-tight text-slate-900 dark:text-slate-100 sm:text-2xl">
            {store?.name}
          </h1>
          <div className="mt-2 flex flex-col gap-1 text-xs text-slate-500 dark:text-slate-400 sm:text-sm">
            {addressLine && (
              <div className="flex items-center gap-2">
                <MapPinIcon className="h-4 w-4 flex-shrink-0 text-slate-400" />
                <span className="truncate">{addressLine}</span>
              </div>
            )}
            {store?.phone && (
              <div className="flex items-center gap-2">
                <PhoneIcon className="h-4 w-4 flex-shrink-0 text-slate-400" />
                <span className="tabular-nums">{store.phone}</span>
              </div>
            )}
          </div>
        </div>
      </div>

      {showActions ? (
        <div className="flex items-center gap-1 self-start rounded-full border border-slate-200 bg-slate-50 p-1 dark:border-slate-700 dark:bg-slate-900/50 sm:self-center">
          <Tooltip id="header-email" />
          <button
            type="button"
            data-tooltip-id="header-email"
            data-tooltip-content="Send email to customer"
            onClick={onClickEmail}
            className={shareBtn}
            aria-label="Send email"
          >
            <EnvelopeIcon className="h-4 w-4" />
          </button>
          <Tooltip id="header-sms" />
          <button
            type="button"
            data-tooltip-id="header-sms"
            data-tooltip-content="Send SMS to customer"
            onClick={onClickSms}
            className={shareBtn}
            aria-label="Send SMS"
          >
            <ChatBubbleBottomCenterTextIcon className="h-4 w-4" />
          </button>
          <Tooltip id="header-link" />
          <button
            type="button"
            data-tooltip-id="header-link"
            data-tooltip-content="Open public receipt link"
            onClick={onClickReceipt}
            className={shareBtn}
            aria-label="Open receipt link"
          >
            <LinkIcon className="h-4 w-4" />
          </button>
        </div>
      ) : null}
    </section>
  );
};

export default StoreHeader;
